
<style>
        .impressum
        {
            max-width:768px;
            margin-left:auto;
            margin-right:auto;
            margin-top:100px;
            margin-bottom:100px;
            
        }
        
        </style>
        
        
 
        
        <div class="impressum">


            <p style="text-align: justify;">
                <strong>{{text.company.organization}}</strong><br />
                <strong>vertretungsberechtigte Gesellschafter: </strong><span *ngFor="let person of text.shareholders">{{person?.first}} {{person?.last}};&nbsp;</span>
                <br />
                {{text.address.street}}<br />
                {{text.address.zip}} {{text.address.city}}
            </p>
            <p style="text-align: justify;">
                <br />
                <strong>Telefon:</strong> {{text.address.tel}}<br />
                <strong *ngIf="text.address.fax.length">Telefax:</strong> {{text.address.fax}}
            </p>
            <p style="text-align: justify;">
                <strong>E-Mail</strong>: {{text.address.email}}
            </p>
            <p style="text-align: justify;">
                <strong>Umsatzsteuer-Identifikationsnummer gem. &sect; 27 a Umsatzsteuergesetz</strong>:{{text.company.ustrnr}}<br />
                <!--		<strong>Wirtschaftsidentifikationsnummer gem. &sect; 139 c Abgabenordnung</strong>: {{text.company.wirtnr}}-->
            </p>
            <p style="text-align: justify;">
                <strong>Verantwortliche i.S.d. &sect; 55 Abs. 2 RStV</strong>: <span  *ngFor="let person of text.shareholders">{{person.first}} {{person.last}};&nbsp;</span>, {{text.address.street}}<br />{{text.address.zip}} {{text.address.city}}
            </p>
        
        
           
            <div>
        